export const AuthMethod = {
  DEFAULT: 'default',
  LOGIN_WITH_SSO: 'sso_saml_2'
};

export const authMethodFromString = (method) => {
  const lower = (method || '').toLowerCase();
  switch (lower) {
    case AuthMethod.DEFAULT:
    case AuthMethod.LOGIN_WITH_SSO:
      return lower;
    default:
      throw Error(`Invalid auth method: ${method}`);
  }
};
